<div class="col-lg-12 add-edit-header-container parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-3 globalborder-btm-header">
        <span class="col-auto d-flex align-items-center gap-2">
          <h2 class="mb-0">Manage Portal Biller/Collector</h2>
          <span class="lds-ring inline" *ngIf="showSmallLoader">
            <jni-spinner></jni-spinner>
          </span>
        </span>
        <span class="d-flex gap-3 customizefilter-btn align-items-center">
          <p-button
            label="New"
            icon="pi pi-plus"
            variant="outlined"
            severity="secondary"
            (click)="addBillerCollectorRedirect()"
            class="fullwdth secondary-btn"
            [style]="{ 'padding-left': '1.5rem', 'padding-right': '1.5rem' }" />
          <p-button
            label="Save"
            icon="pi pi-save"
            (click)="userSave()"
            [style]="{ 'padding-left': '2rem', 'padding-right': '2rem' }" />
        </span>
      </span>

      <div class="p-3">
        <form [formGroup]="billerCollectorForm">
          <div class="row" formGroupName="header">
            <div class="col mb-3">
              <div class="form-group has-float-label">
                <label class="form-label"
                  >User Type<span class="madatory-field">*</span></label
                >
                <p-select
                  [(ngModel)]="userTypeDefaultSelectionId"
                  formControlName="userType"
                  [ngClass]="{ 'has-error': formErrors['userType'] }"
                  [options]="typeList"
                  optionLabel="name"
                  optionValue="name"
                  (onChange)="onUserSelection(userTypeDefaultSelectionId)"
                  (onBlur)="logValidationErrors()">
                </p-select>
                <span class="error-msg" *ngIf="formErrors['userType']">
                  {{ formErrors["userType"] }}
                </span>
              </div>
            </div>

            <div class="col mb-3 user-account adjusttabledropdown">
              <div class="form-group has-float-label">
                <label class="form-label"
                  >Personal Number<span class="madatory-field">*</span></label
                >
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  id="useraccount"
                  name="useraccount"
                  [value]="personnelNumber"
                  formControlName="personnelNumber"
                  (input)="searchUser$.next($any($event.target).value)"
                  (keyup)="onUserSearchOpenToggle($event, mydrop)"
                  (keydown.Tab)="getUserAccount($any($event), mydrop)"
                  [ngClass]="{ 'has-error': formErrors['personnelNumber'] }"
                  (blur)="logValidationErrors()" />
                <span class="error-msg" *ngIf="formErrors['personnelNumber']">
                  {{ formErrors["personnelNumber"] }}
                </span>
              </div>
              <p-popover #mydrop>
                <p-scrollpanel [style]="{ width: '100%', height: '200px' }">
                  <p-table
                    #dt
                    [value]="searchList"
                    styleClass="table-listing"
                    [rowHover]="true"
                    [rows]="10"
                    [showCurrentPageReport]="true"
                    [rowsPerPageOptions]="[10, 25, 50]"
                    [paginator]="false"
                    [filterDelay]="0">
                    <ng-template pTemplate="header">
                      <tr class="table-head">
                        <th>Personal Number</th>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Email</th>
                      </tr>
                    </ng-template>
                    <ng-template
                      pTemplate="body"
                      let-searchList
                      let-rowIndex="rowIndex">
                      <tr
                        class="p-selectable-row mousepointer"
                        (click)="onUserRowSelection(searchList, mydrop)">
                        <td class="personnelNumber mousepointer">
                          {{ searchList.personnelNumber }}
                        </td>
                        <td class="name mousepointer">
                          {{ searchList.firstName }} &nbsp;
                          {{ searchList.lastName }}
                        </td>
                        <td class="phone mousepointer">
                          {{ searchList.displayPhoneNumber }}
                        </td>
                        <td class="email mousepointer">
                          {{ searchList.displayEmailAs }}
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="20">No user found.</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </p-scrollpanel>
              </p-popover>
            </div>

            <div class="col mb-3">
              <div class="form-group has-float-label">
                <label class="form-label"
                  >Name<span class="madatory-field">*</span></label
                >
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  [value]="billerCollectorHeader?.name"
                  [ngClass]="{ 'has-error': formErrors['name'] }"
                  formControlName="name" />
                <span class="error-msg" *ngIf="formErrors['name']">
                  {{ formErrors["name"] }}
                </span>
              </div>
            </div>

            <div class="col mb-3">
              <div class="form-group has-float-label">
                <label class="form-label"
                  >Phone<span class="madatory-field">*</span></label
                >
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  jni-phone-number-formatting
                  [value]="billerCollectorHeader?.phone"
                  [ngClass]="{ 'has-error': formErrors['phone'] }"
                  formControlName="phone" />
                <span class="error-msg" *ngIf="formErrors['phone']">
                  {{ formErrors["phone"] }}
                </span>
              </div>
            </div>

            <div class="col mb-3">
              <div class="form-group has-float-label">
                <label class="form-label"
                  >Email<span class="madatory-field">*</span></label
                >
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  [value]="billerCollectorHeader?.email"
                  [ngClass]="{ 'has-error': formErrors['email'] }"
                  formControlName="email" />
                <span class="error-msg" *ngIf="formErrors['email']">
                  {{ formErrors["email"] }}
                </span>
              </div>
            </div>

            <div class="col mb-3" *ngIf="isCollector">
              <div class="form-group has-float-label">
                <label class="form-label"
                  >Statistics Group<span class="madatory-field">*</span></label
                >
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  [value]="billerCollectorHeader?.statisticsGroup"
                  [ngClass]="{ 'has-error': formErrors['statisticsGroup'] }"
                  formControlName="statisticsGroup" />
                <span class="error-msg" *ngIf="formErrors['statisticsGroup']">
                  {{ formErrors["statisticsGroup"] }}
                </span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </p-card>
  </div>
</div>
